import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { NOT_AVAILABLE, UNKNOWN } from '../../../../common/constants/template.constant';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { LoadPrimary } from '../../../../store/state/monitoring/transport/models/transport-list.model';
import { DISPLAY_DATE_FORMAT } from '../../../../common/constants/date-config';
import { MonitoringPageType } from '../../../../store/state/monitoring/constants';
import { IconNames } from '../../../../common/constants';
import { DeviationType } from '../../../../store';
import { MonitoringStatus, DateType } from '../../../../store/constants';
import { Origin } from '../../../../store/state/monitoring/transport/constants';
import { DirectivesModule } from '../../../../common/directives/directives.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { StatusCodeComponent } from '../../../status-code/status-code.component';
import { TransportModeComponent } from '../../../transport-mode/transport-mode.component';
import { DeviationTypeComponent } from '../../../deviation-type';
import { DatesComponent } from '../../dates/dates.component';
import { InfoFieldListComponent } from '../../../info-field/info-field-list/info-field-list.component';
@Component({
  selector: 'ui-load-card',
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatExpansionModule,
    TranslateModule,
    DirectivesModule,
    PipesModule,
    StatusCodeComponent,
    TransportModeComponent,
    DeviationTypeComponent,
    DatesComponent,
    InfoFieldListComponent,
  ],
  templateUrl: './load-card.component.html',
  styleUrls: ['./load-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadCardComponent {
  @Input() load: LoadPrimary;
  @Input() monitoringPageType: MonitoringPageType;

  notAvailable = NOT_AVAILABLE;
  unknown = UNKNOWN;
  dateFormat = DISPLAY_DATE_FORMAT;
  monitoringStatus = MonitoringStatus;
  transportMode = TransportMode;
  deviationType = DeviationType;
  dateType = DateType;
  origin = Origin;
  iconNameList = IconNames;
}
